/**
 * Global context for shopping cart
 * To access global context: 
 * const { getAdor, updateAdor, emptyAdor } = useAdors();
 */
import React, { createContext, useState, useContext, useEffect } from 'react';

const AdorsContext = createContext();

export function AdorsProvider({ children }) {
  const [adors, setAdors] = useState(() => {
    const storedAdors = sessionStorage.getItem('adors');
    return storedAdors ? JSON.parse(storedAdors) : null;
  });

  /**
   * Set this adors state
   * @param {*} newAdors 
   */
  const saveAdors = (newAdors) => {
    // debugger;
    sessionStorage.setItem('adors', JSON.stringify(newAdors));
    setAdors(newAdors);
  }

  const getAdor = (name) => {
    return adors[name] ? adors[name] : null;
  }

  const getAdorValue = (name, field) => {
    return (adors[name] && adors[name][field]) ? adors[name][field] : null;
  }
  /**
   * Update or add ador value
   * @param {*} name - ador name
   * @param {*} field - ador field
   * @param {*} value - actual value
   */
  const updateAdorValue = (name, field, value) => {
    // debugger;
    if (adors[name]) {
      let prevAdor = { ...adors[name] };
      prevAdor[field] = value;
      setAdors({ ...adors, [name]: prevAdor });
    }
    else {
      let prevAdors = { ...adors };
      prevAdors[name] = { field: value };
      setAdors({ ...adors, prevAdors });
    }
  };

  const emptyAdor = () => {
    setAdors({});
  };

  return (
    <AdorsContext.Provider
      value={{
        adors,
        saveAdors,
        getAdor,
        getAdorValue,
        updateAdorValue
      }}
    >
      {children}
    </AdorsContext.Provider>
  );
}

export function useAdors() {
  return useContext(AdorsContext);
}
